<template>
  <div class="main">
    <h1 style="text-align:center">Welcome to Nomer.uz</h1>
    <p>
      Nomer.uz - Уникальный Веб портал для дилеров и покупателей телефонных номеров.
    </p>
  </div>
</template>

<script>

export default {
    name: 'About',
    metaInfo() {
        return {
            title: 'About',
            meta: [
                {
                    name: 'description',
                    content: `
                      Nomer.uz - Уникальный Веб портал для дилеров и покупателей телефонных номеров.
                    `,
                },
            ],
        };
    },
};
</script>

<style scoped>

.main {
  padding: 20px;
}

</style>
